import { render } from "./CostReportDetailsClass.vue?vue&type=template&id=5b564099&scoped=true"
import script from "./CostReportDetailsClass.vue?vue&type=script&lang=js"
export * from "./CostReportDetailsClass.vue?vue&type=script&lang=js"

import "./CostReportDetailsClass.vue?vue&type=style&index=0&id=5b564099&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b564099"]])

export default __exports__